import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatTooltipTruncateDirective } from '@examdojo/core/mat-tooltip-truncate';
import { MatTooltip } from '@angular/material/tooltip';
import { BaseCellRendererComponent } from '@examdojo/ag-grid';
import {
  SourceStatus,
  SourceListItemHttpModel,
  SOURCE_STATUS_TO_LABEL,
  getSourceStatusClassName,
} from '@examdojo/source';

@Component({
  selector: 'exam-source-list-status-cell-renderer',
  template: `
    @if (status) {
      <div
        [ngClass]="statusClass"
        class="inline-flex max-w-full overflow-hidden rounded-[6px] px-1.5 py-1 text-xs font-semibold"
      >
        <span class="truncate" [matTooltip]="statusLabel">{{ statusLabel }}</span>
      </div>
    }
  `,
  standalone: true,
  imports: [MatTooltipTruncateDirective, MatTooltip, NgClass],
})
export class SourceListStatusCellRendererComponent extends BaseCellRendererComponent<
  SourceStatus | null,
  SourceListItemHttpModel
> {
  get status(): SourceStatus | null {
    return this.params?.data?.status ?? null;
  }

  get statusClass(): string {
    return getSourceStatusClassName(this.status);
  }

  get statusLabel(): string {
    return SOURCE_STATUS_TO_LABEL[this.status!] ?? '';
  }
}
